import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section, StatusBadge, fmtTime } from "@/components/Shared";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function DailyActivity() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);
  const [projects, setProjects] = useState({});
  const [ts, setTs] = useState({});

  const load = async () => {
    try {
      const [a, p] = await Promise.all([api.get(`/dashboard/daily-activity?date=${date}`), api.get("/projects")]);
      setRows(a.data);
      setProjects(Object.fromEntries(p.data.map((x) => [x.id, x])));
    } catch (e) { toast.error(formatErr(e)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [date]);

  const openDetail = async (r) => {
    setSel(r);
    try { const d = await api.get(`/timesheets?user_id=${r.user_id}&from_date=${date}&to_date=${date}`); setTs(d.data[0] || {}); }
    catch { setTs({}); }
  };

  return (
    <div data-testid="admin-activity">
      <PageHeader overline="Operations" title="Daily Employee Activity"
        actions={<Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded-none w-44" />} />
      <Section title={`${rows.length} employees — ${date}`}>
        <table className="w-full table-dense">
          <thead>
            <tr className="border-b-2 border-[#1F4E8C] text-left">
              <th className="eyebrow">Employee</th><th className="eyebrow">In</th><th className="eyebrow">Out</th>
              <th className="eyebrow">Break</th><th className="eyebrow">Total</th><th className="eyebrow">Projects</th><th className="eyebrow">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.user_id} className="border-b border-[#F0F0EE] cursor-pointer hover:bg-[#F7F7F5]" onClick={() => openDetail(r)} data-testid={`activity-${r.user_id}`}>
                <td className="font-medium">{r.name}<div className="text-xs text-neutral-500">{r.department}</div></td>
                <td>{fmtTime(r.clock_in)}</td><td>{fmtTime(r.clock_out)}</td>
                <td>{r.break_minutes}m</td><td className="font-semibold">{r.total_hours}h</td>
                <td>{r.projects_count}</td><td><StatusBadge status={r.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>

      {sel && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 grid place-items-center p-4" onClick={() => setSel(null)}>
          <div className="bg-white border border-[#E5E5E5] max-w-3xl w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6 border-b border-[#E5E5E5]">
              <div className="eyebrow">{date}</div>
              <h2 className="font-head text-2xl font-bold tracking-tight">{sel.name}</h2>
              <div className="text-sm text-neutral-500">{sel.department}</div>
              <div className="grid grid-cols-4 gap-4 mt-4">
                <div><div className="eyebrow">In</div><div className="font-semibold">{fmtTime(sel.clock_in)}</div></div>
                <div><div className="eyebrow">Out</div><div className="font-semibold">{fmtTime(sel.clock_out)}</div></div>
                <div><div className="eyebrow">Break</div><div className="font-semibold">{sel.break_minutes}m</div></div>
                <div><div className="eyebrow">Total</div><div className="font-semibold text-[#FF5500]">{sel.total_hours}h</div></div>
              </div>
            </div>
            <div className="p-6">
              <div className="eyebrow mb-3">Project Activity</div>
              <table className="w-full table-dense">
                <thead><tr className="border-b-2 border-[#1F4E8C] text-left"><th className="eyebrow">Project</th><th className="eyebrow">Task</th><th className="eyebrow">Hours</th><th className="eyebrow">Description</th></tr></thead>
                <tbody>
                  {(ts.entries || []).map((e, i) => (
                    <tr key={i} className="border-b border-[#F0F0EE]">
                      <td>{projects[e.project_id]?.name || "—"}</td>
                      <td>{e.task}</td><td>{e.hours}h</td><td>{e.description}</td>
                    </tr>
                  ))}
                  {(ts.entries || []).length === 0 && <tr><td colSpan={4} className="text-center py-6 text-neutral-500">No timesheet for this day</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
